import { render, staticRenderFns } from "./PersonUpdatePhoto.vue?vue&type=template&id=4dffe534"
import script from "./PersonUpdatePhoto.vue?vue&type=script&lang=js"
export * from "./PersonUpdatePhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports